import * as React from 'react';
import { SpinnerComponent as Spinner } from '../../service/SpinnerComponent';

class Loaderbar extends React.Component {

  render() {
    return(
      <div className="loaderbar">
        <Spinner name="indeterminate" />
        <Spinner name="query" />
        <Spinner name="determinate" />
      </div>
    )
  }
}

export default Loaderbar;
